import Vue from 'vue'
import App from './App.vue'
import router from '@/router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from '@/store';
import VueMeta from 'vue-meta';
Vue.config.productionTip = false
// 引入jQuery
// import $ from 'jquery'

// 挂载到Vue原型
// Vue.prototype.$ = $
// Vue.prototype.jQuery = $
Vue.use(ElementUI);
Vue.use(VueMeta);
// 关键修改：用 beforeEach 替代 afterEach
router.beforeEach((to, from, next) => {
  // 先修改标题，再执行下一步路由跳转
  const pageTitle = to?.meta?.metaInfo?.title || 'CNHONOR';
  document.title = pageTitle;
  // 必须调用 next()，否则路由不会跳转
  next();
})
new Vue({
  mounted() {
    // 预渲染触发事件
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App),
  router,
  store
}).$mount('#app')
